// @ts-strict-check
import React from 'react';
import { TimePeriod } from '../../types/api';
import MarketPulseTableSection from './MarketPulseTableSection';
import { MarketPulseComparisonData } from './marketPulseComparisonData';

interface MarketPulseYoYTableSectionProps {
  branchId?: number;
  customTimeRange?: TimePeriod;
  extrapolateToFullMonth?: boolean;
  comparisonData?: MarketPulseComparisonData;
  className?: string;
}

const MarketPulseYoYTableSection: React.FC<MarketPulseYoYTableSectionProps> = (props) => (
  <MarketPulseTableSection {...props} variant="yoy" />
);

export default MarketPulseYoYTableSection;
